<template lang="pug">
  .b-spec-chat-create
    ._title Чат с поставщиком и заказчиком
    ._line
      ._label Поставщик
      select._select(data-testid="chat-create-supplier" v-model="supplierId")
        option(:value="null" data-testid="chat-create-supplier-option") — выберите —
        option(v-for="supplier in suppliers" :key="supplier.id" :value="supplier.id" data-testid="chat-create-supplier-option") {{ supplier.name }}
    textarea._text(data-testid="chat-create-text" v-model="text" placeholder="Первое сообщение")
    label._attach
      | Прикрепить файлы
      input._file(type="file" multiple data-testid="chat-create-attach-input" @change="onFiles")
    ._attached(v-if="files.length") файлов: {{ files.length }}
    ._error(v-if="error") {{ error }}
    ._buttons
      Btn(blue data-testid="chat-create-submit" :disabled="!canSubmit" @click="submit") Создать
      Btn(grey @click="$emit('finish', false)") Отмена
</template>

<script>
/**
 * Окно создания трёхстороннего чата (ТЗ 6.10, 4.1): поставщик, у которого есть запрос КП в этой
 * спецификации и ещё нет трёхстороннего чата, и первое сообщение — текст и/или вложения.
 * Создаёт чат страница: ей принадлежит список чатов. Сгенерировано Claude.
 */
export default {
  name: 'SpecChatCreatePopupWrappable',
  data() {
    return {
      suppliers: [],
      supplierId: null,
      text: '',
      files: [],
      error: '',
    };
  },
  computed: {
    canSubmit() {
      return !!this.supplierId && (this.text.trim().length > 0 || this.files.length > 0);
    },
  },
  methods: {
    init(params = {}) {
      this.suppliers = params.suppliers ?? [];
    },
    onFiles(event) {
      this.files = Array.from(event.target.files ?? []);
    },
    submit() {
      if (!this.canSubmit) {
        this.error = 'Выберите поставщика и напишите сообщение';
        return;
      }
      this.$emit('finish', {
        supplierId: this.supplierId,
        text: this.text.trim(),
        files: this.files,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.spec-chat-create {
  width: 520px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 14px;

  &__title {
    font-size: 24px;
    font-weight: 700;
  }

  &__line {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__label {
    width: 120px;
    font-size: 13px;
  }

  &__select {
    flex-grow: 1;
    box-sizing: border-box;
    padding: 6px 8px;
    border: 1px solid var(--color-super-light);
    border-radius: 6px;
    font: inherit;
  }

  &__text {
    box-sizing: border-box;
    width: 100%;
    min-height: 90px;
    padding: 8px 10px;
    border: 1px solid var(--color-super-light);
    border-radius: 6px;
    font: inherit;
    font-size: 13px;
    resize: vertical;
  }

  &__attach {
    color: var(--color-accent);
    cursor: pointer;
    font-size: 13px;
  }

  &__file {
    position: absolute;
    opacity: 0;
    visibility: hidden;
  }

  &__attached {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__error {
    color: var(--color-red);
  }

  &__buttons {
    display: flex;
    gap: 12px;
  }
}
</style>
